module.exports = __webpack_public_path__ + "static/media/vans.1b244d09.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Repertoire/assets/vans.png
// module id = 525
// module chunks = 0